type Props = {
  height: number | string;
};

const Br: React.FC<Props> = ({ height = 20 }) => {
  return <div style={{ height }}></div>;
};

export default Br;
